import { render, staticRenderFns } from "./EModalComportamento.vue?vue&type=template&id=40a773cf"
import script from "./EModalComportamento.vue?vue&type=script&lang=js"
export * from "./EModalComportamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports